import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Collapse, Typography } from 'antd';
import styled from 'styled-components';

import { Card, Heading, Section } from 'components';
import { Formik } from 'formik';
import RadioInput from 'components/forms/RadioInput';
import SliderInput from 'components/forms/SliderInput';
import TextInput from 'components/forms/TextInput';
import { withI18n } from '@lingui/react';
import { t, Trans } from '@lingui/macro';
import { countryMap } from 'helpers/countryMapping';
import { country } from 'App';
import { mobile, pricer } from 'helpers';
import { useLifelongCategories } from 'helpers/hooks/data';

const StyledSection = styled(Section)`
	padding-bottom: 1.5em;
	&& {
		article {
			margin-bottom: 0.5em;
		}
	}
	.ant-checkbox-group-item {
		display: block;
	}
	h4.ant-typography {
		font-size: 1em;
	}
	.ant-radio-wrapper {
		display: block;
		text-overflow: ellipsis;
		width: 160px;
		white-space: pre;
		overflow-x: hidden;
	}
`;

const StyledInput = styled(TextInput).attrs({
	size: 'large'
})`
	&& {
		margin-top: -30px;
		margin-bottom: 0;
		input[name='keywords'] {
			border-radius: 8px;
		}
	}
`;

const StyledCollapse = styled(Collapse)`
	&& {
		background-color: transparent;
		.ant-collapse-item {
			&:first-child {
				margin-bottom: 2em;
			}

			.ant-collapse-content-box {
				padding: 0;
			}

			.ant-collapse-header {
				padding: 1em 0;
				.ant-collapse-arrow {
					right: 0;
				}
			}
		}
	}
`;

function FilteringPanel({ onUsers, i18n, citiesoption }) {
	const { options: categoryOptions } = useLifelongCategories();
	const stringifiedCategoryOptions = categoryOptions.map(item => ({ ...item, value: String(item.value) }));

	const { handleSearchFilter, handleChangeSlider } = onUsers;
	const maxRange = countryMap[country].pricePerHourRange.range[1];
	const minRange = countryMap[country].pricePerHourRange.range[0];
	const symbol = countryMap[country].symbol;
	const step = countryMap[country].pricePerHourRange.step;
	const minRangeShortened =
		String(minRange).slice(-3) === '000'
			? symbol + String(minRange).slice(0, String(minRange).length - 3) + 'k'
			: symbol + pricer(minRange);
	const maxRangeShortened =
		String(maxRange).slice(-3) === '000'
			? symbol + String(maxRange).slice(0, String(maxRange).length - 3) + 'k'
			: symbol + pricer(maxRange);

	return (
		<Card title="" autoheight style={{ marginTop: '1em' }}>
			<Formik
				initialValues={{
					nonAcademicPvid: '0',
					curriculums: 0,
					price_range: countryMap[country].pricePerHourRange.range,
					cities: 'All'
				}}>
				{() => (
					<Form layout="vertical">
						<StyledInput
							name="keywords"
							placeholder={i18n._(t`E.g. Felix Ong, or Surabaya...`)}
							onPressEnter={handleSearchFilter('keywords')}
							helpText={i18n._(t`You can search either by tutor's name or city/province`)}
							allowClear
						/>
						<StyledSection noPadding className="pb0 mb0">
							<Heading content={<Trans>Price per hour</Trans>} level={4} />
							<SliderInput
								range
								name="price_range"
								marks={{
									[minRange]: <Typography.Paragraph ellipsis>{minRangeShortened}</Typography.Paragraph>,
									[maxRange]: <Typography.Paragraph ellipsis>{maxRangeShortened}</Typography.Paragraph>
								}}
								tipFormatter={price => symbol + pricer(price)}
								step={step}
								min={0}
								max={maxRange}
								onAfterChange={handleChangeSlider}
							/>
						</StyledSection>
						<StyledCollapse bordered={false} expandIconPosition="right" defaultActiveKey={!mobile && ['nonAcademicPvid']}>
							<Collapse.Panel header={<Trans>Categories</Trans>} key="nonAcademicPvid">
								<RadioInput
									labelBlock
									name="nonAcademicPvid"
									isButton={false}
									options={[
										{
											value: 'all',
											label: <Trans>All</Trans>
										},
										...stringifiedCategoryOptions
									]}
									onChange={handleSearchFilter('nonAcademicPvid')}
								/>
							</Collapse.Panel>
							<Collapse.Panel header={<Trans>Cities</Trans>} key="Cities">
								<RadioInput
									labelBlock
									name="cities"
									isButton={false}
									options={[{ value: 'All', label: <Trans>All</Trans> }, ...citiesoption]}
									onChange={handleSearchFilter('cities')}
								/>
							</Collapse.Panel>
							{/* <Collapse.Panel header={<Trans>Subjects</Trans>} key="subjects">
								<RadioInput
									labelBlock
									name="subjects"
									isButton={false}
									options={[{ value: 0, label: <Trans>All</Trans> }, ...subjOptions]}
									onChange={handleSearchFilter("subjects")}
								/>
							</Collapse.Panel> */}
						</StyledCollapse>
					</Form>
				)}
			</Formik>
		</Card>
	);
}

export default withI18n()(FilteringPanel);
